import { render, staticRenderFns } from "./LightBox.vue?vue&type=template&id=461a94f3&scoped=true"
import script from "./LightBox.vue?vue&type=script&lang=js"
export * from "./LightBox.vue?vue&type=script&lang=js"
import style0 from "./LightBox.vue?vue&type=style&index=0&id=461a94f3&prod&lang=css"
import style1 from "./LightBox.vue?vue&type=style&index=1&id=461a94f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461a94f3",
  null
  
)

export default component.exports